import { render } from "./CardTagEditor.vue?vue&type=template&id=772726b4&scoped=true&ts=true"
import script from "./CardTagEditor.vue?vue&type=script&lang=ts"
export * from "./CardTagEditor.vue?vue&type=script&lang=ts"

import "./CardTagEditor.vue?vue&type=style&index=0&id=772726b4&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772726b4"]])

export default __exports__